import React from 'react';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import './customPagination.css'
import { t } from '../../../locales/translate';
const CustomPagination = ({ currentPage, totalItems, itemsPerPage, onPageChange, totalPages }) => {
  const startItem = (currentPage - 1) * itemsPerPage + 1;
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  const isRTL = document.body.dir === 'rtl';

  const handlePrev = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };
  const buttonStyle = {
    paddingRight: '12px', 
  };
  return (
    <div className="custom-pagination ">
      <span><span>
      {isRTL
        ? `${totalItems} ${t("of")} ${startItem} - ${endItem}`
        : `${startItem} - ${endItem} ${t("of")} ${totalItems}`}
    </span>
    </span>
    <div style={{display: "flex", flexDirection: isRTL ? 'row-reverse' : 'row',}}>
      <button onClick={handlePrev} disabled={currentPage === 1} style={buttonStyle}>
        <ArrowBackIosNewIcon />
      </button>
      <button onClick={handleNext} disabled={currentPage === totalPages} style={buttonStyle}>
        <ArrowForwardIosIcon />
      </button>
    </div>
    </div>
  );
};

export default CustomPagination;
